import styled from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const ContainerFooterStyled = styled.footer`
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: var(--violetaOscuro);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.85);
  font-family: ${FONT_STACK};
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  -webkit-font-smoothing: antialiased;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(
      90deg,
      var(--naranja) 0%,
      var(--violeta) 50%,
      var(--violetaPastel) 100%
    );
  }

  @media (max-width: 800px) {
    position: absolute;
  }

  @media (max-width: 1023px) {
    position: absolute;
  }
`;
